import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/utils/cn';

const valueVariants = cva('text-h2', {
  variants: {
    tone: {
      default: 'text-ui-text',
      accent: 'text-accent-text',
      success: 'text-success-text',
      warning: 'text-warning-text',
      danger: 'text-danger-text',
    },
  },
  defaultVariants: { tone: 'default' },
});

export interface StatCardProps extends VariantProps<typeof valueVariants> {
  label: React.ReactNode;
  value: React.ReactNode;
  className?: string;
}

/** Summary tile ("Total tenants 42") for the top of admin list pages. */
export const StatCard: React.FC<StatCardProps> = ({ label, value, tone, className }) => (
  <div className={cn('card-surface p-4', className)}>
    <p className="mb-1 text-xs font-medium text-ui-text2">{label}</p>
    <p className={valueVariants({ tone })}>{value}</p>
  </div>
);

export default StatCard;
